import AlertBanner from "./components/AlertBanner";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import NewsSection from "./components/NewsSection";
import CTASection from "./components/CTASection";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <AlertBanner />
      <Header />
      <main className="flex-1">
        <HeroSection />
        <ServicesSection />
        <NewsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}